import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
// Prototype stylesheet, lines 7-881, split by area — the import order preserves the original cascade.
import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/responsive.css';
import './styles/print.css';
import './styles/pages.css';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { ConfirmProvider } from './components/ui/ConfirmDialog';
import { ToastProvider } from './components/ui/Toast';
import { queryClient } from './lib/queryClient';
import { startPwa } from './pwa/registerSW';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element');

// online/offline state, service-worker registration (production / VITE_ENABLE_SW) and update detection
startPwa();

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <ConfirmProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ConfirmProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
